import { type DomainAccessControlConfig } from 'domains/catalog-admin/utils/domain/accessControl'
import { Permission } from 'domains/catalog-admin/access-control/permissions'
import { Flipper } from 'domains/catalog-admin/access-control/flippers'

export const catalogAdminAdminAccessControl: DomainAccessControlConfig = {}
